import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IRankingProductSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const RankingProductSection = styled.div<IRankingProductSectionProps>`
  position: relative;
  padding: 32px 0;
  background: #fff;
  text-align: center;

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .main-title,
      .sub-title {
        color: ${$textColor};
      }

      .update-time {
        color: #acacac !important;

        svg g {
          fill: #acacac !important;
        }
      }

      .category-tab {
        .menubar-swiper {
          background: ${$bgColor};
        }

        .menubar-item {
          .area-click {
            color: ${$textColor};
          }

          &.active .area-click {
            background: ${$pointColor};
            color: ${$emphasisTextColor};
          }
        }

        .menu2line-item {
          &.active {
            background: ${$pointColor};
            border-color: ${$pointColor};

            .text {
              color: ${$emphasisTextColor};
            }
          }
        }
      }

      .product-item .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }

      .btn-section-more {
        background: transparent;

        .text {
          color: ${$textColor};
        }

        svg path {
          stroke: ${$textColor};
        }
      }
    `}

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .category-tab {
      .menubar-swiper {
        background: #000;

        .menubar-item {
          &.active .area-click {
            color: #000;
            background: #fff;
          }

          .area-click {
            color: #e2e2e2;
          }
        }
      }
    }

    .btn-section-more {
      background: transparent;
      border-color: #555;

      .text {
        color: #fff;
      }

      svg path {
        stroke: #fff;
      }
    }
  }

  .section-title {
    padding-bottom: 19px;
  }

  .update-time {
    position: absolute;
    top: 35px;
    right: 20px;
    font-size: 13px;
    line-height: 130%;
    color: #999;

    svg {
      width: 14px;
      height: 14px;
      vertical-align: sub;
      margin-right: 2px;
    }
  }

  .category-tab {
    background: transparent;
  }

  .skeleton-list {
    padding: 0 20px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .section-title {
      padding-bottom: ${mixin.pxToVw('19')};
    }

    .update-time {
      top: ${mixin.pxToVw('35')};
      right: ${mixin.pxToVw('20')};
      font-size: ${mixin.pxToVw('13')};

      svg {
        width: ${mixin.pxToVw('14')};
        height: ${mixin.pxToVw('14')};
        margin-right: ${mixin.pxToVw('2')};
      }
    }

    .skeleton-list {
      padding: ${mixin.pxToVw('0 20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    &.bg-type-black {
      .category-tab {
        .menu2line-item {
          color: #ccc;
          border-color: #555;

          &.active {
            background: #fff;

            .text {
              color: #000;
            }
          }
        }
      }
    }

    .section-title {
      padding-bottom: 20px;
    }

    .update-time {
      top: 75px;
      right: 57px;
      font-size: 16px;

      svg {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }

    .category-tab {
      ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })};
      gap: 12px;
      margin-bottom: 20px;
    }

    .items-grid {
      min-height: 763px;
    }
  }
`;
